module.exports = __webpack_public_path__ + "static/sparkles-09e8e60f3f0bb399651553eb94e5489f.gif";